import { z } from 'zod'
export const zPersonalOsagoInsuranceScenarioResult = z.object({
  externalId: z.string().nullable().optional(),
  price: z.coerce.number().nullable().optional(),
  otherData: z.record(z.string(), z.any()).default({}),
})
export type PersonalOsagoInsuranceScenarioResult = z.infer<typeof zPersonalOsagoInsuranceScenarioResult>
export const personalOsagoInsuranceScenarioResultMap: Record<keyof PersonalOsagoInsuranceScenarioResult, string> = {
  externalId: 'Номер страховки на сайте страховой компании',
  price: 'Стоимость страховки',
  otherData: 'Прочее',
}
export const personalOsagoInsuranceScenarioResultDefaultValues: PersonalOsagoInsuranceScenarioResult = {
  externalId: null,
  price: null,
  otherData: {},
}
